export const RESPONSIBLE_GAMING = 'ngresponsiblegaming';
